import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _mergeProps({
    class: "bar",
    style: {
      ...$options.barWidth
    }
  }, _ctx.$attrs), null, 16);
}